import {
  observable,
  action
} from 'mobx';
import base from '../../tool/base';
import {
  message
} from 'antd';
import util from '../../util/index';
const {
  catchApiError,
  getAccessToken
} = util;

export class CommonStore {

  constructor(routing) {
    this.routing = routing;
    this.setApplyModal = this.setApplyModal.bind(this);
    this.callApply = this.callApply.bind(this);
    this.getApply = this.getApply.bind(this);
  }

  @observable applyModal = {
    visible: false,
    title: "表单获取",
    loading: false,
    appId: '',
    appName: ''
  };

  @observable applyApps = {
    flow4AppAll: '',
    flow4App: ''
  };
  @action

  setApplyModal(params = {}) {
    this.applyModal = {
      ...this.applyModal,
      ...params
    };
  }
  //申请应用
  callApply(params, appInfo) {
    params.orderType = '3';
    let param = {
      order: JSON.stringify(params),
      access_token: getAccessToken(),
      cloudStore: 1,
    };
    this.setApplyModal({
      visible: true,
      loading: true,
      appInfo: appInfo
    });
    base.callApi('/v2/order/add', 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
      if (data.status === 'true') {
        base.callApi('/v4/apply/apps?sw_ids=' + params.sw_id + '&&cloudStore=1', 'GET', {}, 'json', 'text').then(data => {
          this.applyApps = data;
          this.setApplyModal({
            loading: false
          });
        })
      } else {
        this.setApplyModal({
          visible: false
        });
        message.success(data.msg ? data.msg : '获取失败，请重试！');
      }
    });
  }


  getApply(params = {}, appInfo) {
    this.setApplyModal({
      visible: true,
      loading: true,
      appInfo: appInfo
    });
    base.callApi('/v4/apply/apps?sw_ids=' + params.sw_id + '&&cloudStore=1', 'GET', {}, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(data => {
      this.applyApps = data;
      this.setApplyModal({
        loading: false
      });
    })
  }
  @action
  view = (app) => {
    this.getAppDetail(app).then((data) => {
      if (data.app && data.app.s_ispreview === '1') {
        if (data.app.s_mobiurl) {
          window.open(`http://e8pc.e-cology.com.cn/mobilemode/apps/online/index_cs.html?url=${data.app.s_mobiurl}`, '_blank');
        } else if (data.app.s_pcurl) {
          window.open(`http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=${data.app.s_pcurl}`, '_blank');
        } else {
          window.open(`http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=/cloudstore/system/index.jsp#/${data.app.s_number}/set`, '_blank');
        }
      } else {
        message.info('该应用暂不支持预览');
      }
    });
  }
  @action
  getAppDetail = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      type: 'get',
    };
    return new Promise(resolve => {
      base.callApi(`/v1/app/${params.sw_id}`, 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status !== 'false') {
          resolve(data);
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/common/CommonStore.js